<template>
  <HgModal
    v-model="internalModel"
    data-cy="no-active-agency-modal"
    fullScreenMobile
    closeButtonCssClass="no-active-agency-modal__close"
    @close="logout"
  >
    <template #title
      ><span class="no-active-agency-modal__title">{{
        t('agency.noActiveAgencyModal.modalTitle')
      }}</span></template
    >
    <template #default>
      <p>{{ t('agency.noActiveAgencyModal.modalDescription') }}</p>
    </template>
    <template #footer>
      <HgButton @click="logout">{{ t('agency.noActiveAgencyModal.logout') }}</HgButton>
    </template>
  </HgModal>
</template>

<script lang="ts" setup>
import { HgButton, HgModal } from '@smg-real-estate/domus';
import { computed } from 'vue';

import routeNames from '@/router/routes/routeNames';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();

interface Props {
  modelValue: boolean;
}
const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);

const router = useRouter();

const internalModel = computed({
  get() {
    return props.modelValue;
  },
  set(val: boolean) {
    emit('update:modelValue', val);
  },
});

const logout = () => router?.push({ name: routeNames.logout });
</script>

<style lang="scss">
.no-active-agency-modal__close {
  display: none;
}
</style>
